export default __webpack_public_path__ + "static/media/about.e6898a3c.png";